import React from 'react';
import {Dialog, DialogBody, DialogFooter, DialogHeader, Text} from '@gravity-ui/uikit';
import {ProjectTransferDTO} from '../../../../entities';
import {formatCurrency} from '../../../../shared';
import styles from './ProjectTransferConfirmModal.module.scss';

interface ProjectTransferConfirmModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  formData: ProjectTransferDTO | null;
  onConfirm: () => void;
  isLoading: boolean;
}

export const ProjectTransferConfirmModal = ({
  open,
  setOpen,
  formData,
  onConfirm,
  isLoading,
}: ProjectTransferConfirmModalProps) => {
  if (!formData) return null;

  return (
    <Dialog size="s" hasCloseButton open={open} onClose={() => setOpen(false)}>
      <DialogHeader caption="Проверочный экран" />
      <DialogBody>
        <div className={styles.amount}>
          <Text variant="subheader-1">Сумма доната:</Text>
          <Text>{formatCurrency(formData.amount, {padFraction: true})}</Text>
        </div>
      </DialogBody>
      <DialogFooter
        onClickButtonCancel={() => setOpen(false)}
        onClickButtonApply={onConfirm}
        propsButtonApply={{
          size: 'l',
          loading: isLoading,
          view: 'action',
        }}
        propsButtonCancel={{size: 'l'}}
        textButtonApply="Внести средства"
        textButtonCancel="Отменить"
      />
    </Dialog>
  );
};
